import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { SosModal } from './sos-modal/sos.modal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NetworkProvider } from '../../providers/network/network';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import {
  GeoLocalisationProvider,
  LocalisationPermissionStatus,
} from '../../providers/geolocalisation/geolocation.provider';

@Component({
  selector: 'sos',
  templateUrl: './sos.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './sos.component.scss',
  imports: [IonicModule],
})
export class SOSComponent implements OnInit {
  private readonly networkProvider: NetworkProvider = inject(NetworkProvider);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly alertCtrl: AlertController = inject(AlertController);
  private readonly modalController = inject(ModalController);
  private readonly destroyRef = inject(DestroyRef);
  private readonly geoLocalisationProvider = inject(GeoLocalisationProvider);

  readonly isOnline: WritableSignal<boolean> = signal<boolean>(false);

  ngOnInit(): void {
    this.networkProvider.networkStatusSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.isOnline.set(this.networkProvider.isConnected());
    });
  }

  async openSOS() {
    if (!this.isOnline()) {
      await this.offlineAlert();
    } else if (await this.checkLocalisationPermission()) {
      const modal = await this.modalController.create({
        component: SosModal,
      });
      await modal.present();
    }
  }

  async checkLocalisationPermission(): Promise<boolean> {
    const status: LocalisationPermissionStatus = await this.geoLocalisationProvider.verifierPermissionsGeoloc();
    return status === 'granted' || status === 'no_fine_localisation';
  }

  private async offlineAlert() {
    let alert = await this.alertCtrl.create({
      subHeader: this.translate.instant('PTI.MESSAGES.OFFLINE'),
      buttons: [
        {
          text: this.translate.instant('GLOBAL.OK'),
        },
      ],
    });

    await alert.present();
  }
}
